import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { BlogDeleteRequestBody, BlogDeleteResponse } from "./types";

export class BlogDeleteAPI extends BaseAPI<
    BlogDeleteRequestBody,
    BlogDeleteResponse
> {
    protected route = ApiRoutes.blog.delete;
    protected method = RequestMethod.DELETE;
    protected params = ["id"]
}
